<template>
  <div class="container-warp exam-page">
    <Top-Nav :pageTitle="paperTitle"
             :leftArrow="false"></Top-Nav>
    <!-- 顶部信息 -->
    <div class="top-info van-hairline--bottom">
      <div class="top-info-left">
        <span>{{currentQuestionIndex+1}}</span> / <span>{{questionTotal}}</span>
      </div>
      <div class="top-info-mid">
        <span class="text-danger">剩余时间:{{ examTimeStr }}</span>
      </div>
      <div class="top-info-right">
        分值:{{currentQuestionScore}}
      </div>
    </div>
    <!-- 试题内容 -->
    <div class="main-content">
      <Question-exam v-if="currentQuestionData"
                     :questionItem="currentQuestionData"></Question-exam>
    </div>

    <!-- 底部功能区 -->
    <div class="bottom-func van-hairline--top">
      <div class="bottom-func-left">
        <div class="icon-btn"
             v-preventReClick="2000"
             @click="handleSubmit(false)">
          <van-icon name="upgrade"
                    size="36"
                    color="#ed5565" />
          <span class="text-danger">交 卷</span>
        </div>
        <div class="icon-btn"
             @click="openPaperOrderDialog">
          <van-icon name="apps-o"
                    size="36"
                    color="#409EFF" />
          <span class="text-primary">答题卡</span>
        </div>
      </div>
      <div class="bottom-func-right">
        <van-button icon="revoke"
                    type="info"
                    class="bottom-func-btn"
                    :disabled="currentQuestionIndex === 0"
                    @click="handlePrevQuestion"></van-button>
        <van-button type="info"
                    class="bottom-func-btn"
                    :disabled="currentQuestionIndex === questionTotal - 1"
                    @click="handleNextQuestion">下一题</van-button>
      </div>
    </div>

    <!-- 考试须知 -->
    <van-dialog v-model="dialogShow"
                width="90%"
                title="考试须知"
                confirm-button-text="我已知悉，开始考试"
                :show-cancel-button="false"
                @confirm="handleDialogConfirm">
      <div class="notice-content"
           v-html="noticeContent"></div>
    </van-dialog>
  </div>
</template>

<script>
import { findPendingExamById, submitPaper, startExam } from "@/api/exam.js";
import funcDialog from "@/components/BaseFuncDialog/funcDialog";
import QuestionExam from "@/components/QuestionExam/QuestionExam.vue";
import dayjs from "dayjs";
export default {
  name: 'DoExam',
  components: { QuestionExam },
  data() {
    return {
      paperTitle: '考试名称',
      examId: null,
      examPaperId: null,
      examStuId: null,
      totalScore: 0,
      passScore: 0,
      examTime: 0, // 考试时间（秒）
      examTimeStr: '00时00分00秒', // 考试时间（字符串）
      timer: null, // 计时器
      questionTotal: 0, // 题目总数
      currentQuestionIndex: 0, // 当前题目序号
      examPaperModules: [],
      dialogShow: false,
      noticeContent: '',
      examTimeM:'',//考试时间（分钟）
    }
  },
  computed: {
    currentQuestionData() {
      if (this.examPaperModules.length === 0) return null
      let allQuestions = this.examPaperModules.reduce((pre, cur) => {
        return [...pre, ...cur.questions]
      }, [])
      return allQuestions[this.currentQuestionIndex]
    },
    currentQuestionScore() {
      return this.currentQuestionData?.scoreStr || '0'
    }
  },
  watch: {
    examTime(newValue) {
      if (newValue <= 0) {
        this.endTimer()
        this.handleSubmit(true)
      }
    }
  },
  created() {
    this.getExamPaperData()
  },
  beforeDestroy() {
    this.endTimer();
  },
  methods: {
    // 获取考试信息
    async getExamPaperData() {
      const { examId, examPaperId, examStuId } = this.$route.query
      this.examId = examId
      this.examPaperId = examPaperId
      this.examStuId = examStuId

      const params = { id: this.examId, paperId: this.examPaperId };
      console.log(params,'params');
      const { status, data } = await findPendingExamById(params);
      if (status == 200) {
        // 赋值考试信息
        this.paperTitle = data.examPaperName;
        this.totalScore = data.examScore;
        this.passScore = data.passScore;
        this.examTime = (data.examTime || 0) * 60; // 返回的数据为分钟，转换为秒
        this.examTimeM  = data.examTime || 0;//保留分钟数
        this.formatExamTime(); // 格式化考试时间

        // 赋值题目数据
        let examPaperModules = data.modules.map((item) => {
          // 题目和答案都在questionVM中
          const questList = item.questions.map((quest) => {
            // 赋值题目分数
            quest.questionVM.scoreStr = quest.scoreStr;
            const copyQuestionBaseData = JSON.parse(JSON.stringify(quest));
            quest.questionVM.questionId = copyQuestionBaseData.id;
            delete copyQuestionBaseData.questionVM;
            delete copyQuestionBaseData.question;
            quest.questionVM.correctArray = [];
            quest.questionVM.questionBaseData = copyQuestionBaseData;
            return quest.questionVM;
          });

          item.questions = [...questList];
          return item;
        });

        // 生成题目序号
        let questionOrder = 1;
        examPaperModules.forEach((item) => {
          item.questions.forEach((quest) => {
            quest.itemOrder = questionOrder;
            questionOrder++;
          });
        });
        this.questionTotal = questionOrder - 1;
        // console.log(examPaperModules)
        this.examPaperModules = examPaperModules;
        this.openExamStartDialog(data.noticeContent)
      }
    },
    // 考试开始弹窗
    openExamStartDialog(noticeContent) {
      if (noticeContent) {
        this.noticeContent = noticeContent
        this.dialogShow = true
      } else {
        this.handleStartExam()
      }
    },
    // 考试须知弹窗确认
    handleDialogConfirm() {
      this.handleStartExam()
    },
    // 开始考试
    async handleStartExam() {
      const params = {
        id: this.examStuId,
        startTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        examId:this.examId,
        examTime:this.examTimeM
      }
      const { status, data } = await startExam(params)
      if (status == 200) {
        if(data&&(typeof data === 'number'||typeof data === 'string')){
          this.examTime = data
          this.formatExamTime(); // 格式化考试时间
        }
        this.startTimer()
      }
    },
    // 答题卡弹窗
    async openPaperOrderDialog() {
      try {
        const cbParams = await funcDialog({
          title: '答题卡',
          dialogAttributes: {
            width: '100%',
            height: '86%',
            position: 'bottom',
            closeable: true
          },
          contentComponent: () => import('./components/paper-order.vue'),
          dialogParams: { examPaperModules: [...this.examPaperModules], action: 'do' },
        })

        this.currentQuestionIndex = cbParams.currentIndex
      } catch (cbParams) {
        console.log(cbParams)
      }
    },
    // 上一题
    handlePrevQuestion() {
      if (this.currentQuestionIndex > 0) {
        this.currentQuestionIndex--;
      }
    },
    // 下一题
    handleNextQuestion() {
      if (this.currentQuestionIndex < this.questionTotal) {
        this.currentQuestionIndex++;
      }
    },
    // 交卷
    handleSubmit(timeOver = false) {
      const msg = timeOver ? '考试时间已到，点击【确定】结束本次考试！' : '确定结束本次考试吗？'
      this.$dialog({
        title: '提示',
        showClose: !timeOver,
        message: msg,
        showCancelButton: !timeOver,
        closeOnClickOverlay: false
      }).then(() => {
        this.endTimer()
        this.handleSubmitPaper()
      })
    },
    // 提交试卷
    async handleSubmitPaper() {
      const params = {
        examStuId: this.examStuId,
        examId: this.examId,
        answers: [],
      };
      // 赋值答案
      this.examPaperModules.forEach((item) => {
        item.questions.forEach((temp) => {
          if (temp.questionType === 2 || temp.questionType === 4) {
            params.answers.push({
              questionId: temp.questionId,
              stuAnswer: !temp.correctArray ? null : temp.correctArray.length ? temp.correctArray.join(",") : '',
              answerResult: null,
              correctAnswer: "",
              answerScore: null,
            });
          } else {
            params.answers.push({
              questionId: temp.questionId,
              stuAnswer: temp.correct,
              answerResult: null,
              correctAnswer: "",
              answerScore: null,
            });
          }
        });
      });
      // console.log(params);

      const { status } = await submitPaper(params)
      if (status == 200) {
        this.$toast({
          type: 'success',
          message: '提交成功',
          duration: 2000,
          forbidClick: true,
          onClose: () => {
            // this.pageBack()
            this.$router.push({
              path: '/index'
            })
          }
        })
      }
    },
    // 计时开始    
    startTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        this.examTime--;
        this.formatExamTime();
      }, 1000);
    },
    // 计时结束
    endTimer() {
      clearInterval(this.timer);
    },
    // 格式化考试时间
    formatExamTime() {
      const h = Math.floor(this.examTime / 3600);
      const m = Math.floor(this.examTime % 3600 / 60);
      const s = Math.floor(this.examTime % 60);
      this.examTimeStr = `${h < 10 ? '0' + h : h}时${m < 10 ? '0' + m : m}分${s < 10 ? '0' + s : s}秒`;
    },
  },
}
</script>

<style lang="less" scoped>
@import url("~@/assets/css/exam-page.less");
</style>